import { ChatGptApiClient } from './ChatGptApiClient';
import StoryGeneratorApiService from './StoryGeneratorApiService';

const chatgptApiClient = new ChatGptApiClient();
export const StoryGeneratorService = new StoryGeneratorApiService(chatgptApiClient);
